const SERVICE_KEYS = [
  "Wedding",
  "Events",
  "Corporate",
  "Fashion",
  "Product",
  "Food",
  "Automobile",
  "Maternity & Baby",
  "Sports",
];

/**
 * Maps quote eventType / serviceName (e.g. "Wedding Photography") to
 * ConversationalQuote flow key (e.g. "Wedding").
 */
export function mapEventTypeToConversationalService(eventType = "") {
  const text = String(eventType).trim();
  if (!text) return null;

  const lower = text.toLowerCase();

  const direct = SERVICE_KEYS.find((k) => k.toLowerCase() === lower);
  if (direct) return direct;

  if (lower.includes("wedding")) return "Wedding";
  if (lower.includes("corporate")) return "Corporate";
  if (lower.includes("fashion")) return "Fashion";
  if (lower.includes("product")) return "Product";
  if (lower.includes("food")) return "Food";
  if (lower.includes("automobile") || lower.includes("auto")) return "Automobile";
  if (lower.includes("maternity") || lower.includes("baby")) return "Maternity & Baby";
  if (lower.includes("sport")) return "Sports";
  if (
    lower.includes("event") ||
    lower.includes("birthday") ||
    lower.includes("anniversary") ||
    lower.includes("party")
  ) {
    return "Events";
  }

  const partial = SERVICE_KEYS.find((k) => lower.includes(k.toLowerCase()));
  return partial || null;
}

export default mapEventTypeToConversationalService;
